module.exports = __webpack_public_path__ + "images/hummer_small917373dce9865536f489224d5978963e.png";